"use strict";

exports.__esModule = true;
exports.getErrorID = void 0;
/**
 * 获取错误对象唯一标识
 */
var getErrorID = exports.getErrorID = function getErrorID(error) {
  var _error$message = error.message,
    message = _error$message === void 0 ? '' : _error$message,
    _error$stack = error.stack,
    stack = _error$stack === void 0 ? '' : _error$stack;
  return message + stack;
};